import React from "react";
const authContext = React.createContext({
	SearchVal: (val) => {},
	inputItem: "",
});

export default authContext;
